import React, {useEffect, useRef, useContext, useState} from 'react';
import EncDateRangePicker from '../../../../../../components/date-range-picker/EncDateRangePicker';
import NoResultsMessage from '../../../../../../components/table-select/NoResultsMessage';
import { Button } from 'semantic-ui-react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import columnConfig from './user-profiles.column-config';
import PageableTableSelect from '../../../../../../components/table-select/pageable/PageableTableSelect';
import { MobXProviderContext } from 'mobx-react';
import { useParams } from 'react-router-dom';

const UserProfiles = observer(() => {
    const { t } = useTranslation();
    const { userId } = useParams();
    const { profileStore, userProfilesUIStore, userStore } = useContext(MobXProviderContext);
    const tableSelectRef = useRef(null);
    const [tableSelectFilter, setTableSelectFilter] = useState('');

    const setTableSelectRef = (node) => {
        tableSelectRef.current = node;
    };

    useEffect(() => {
        userStore.retrieveUser(userId);

        return () => {
            userProfilesUIStore.reset();
        };
    }, [userId, userStore, userProfilesUIStore]);

    const exportProfilesToCSV = () => {
        profileStore.exportToCsv(
            userProfilesUIStore.dateRange,
            tableSelectFilter,
            undefined,
            { contactId: userId, contactName: userStore.user.partnerUserId }
        );
    };

    const handleTextFilterChange = filter => {
        if (tableSelectRef.current) {
            setTableSelectFilter(filter);
        }
    };

    const getPageableProfiles = (...params) => {
        profileStore.getPageableProfiles(userProfilesUIStore.dateRange, undefined, userId)(...params);
    };

    const renderAdditionalFilteringComponents = () => (
        <EncDateRangePicker
            startDate={userProfilesUIStore.dateRange.startDate}
            endDate={userProfilesUIStore.dateRange.endDate}
            handleRange={dateRange => {
                userProfilesUIStore.setDateRange(dateRange);
                if (tableSelectRef.current) {
                    tableSelectRef.current.refreshTable();
                }
            }}
        />
    );

    const renderNoResultsMessage = () => (
        <NoResultsMessage
            tableData={profileStore.profiles}
            startDate={userProfilesUIStore.dateRange.startDate}
            endDate={userProfilesUIStore.dateRange.endDate}/>
    );

    return (
        <div className="content sticky-scroll">
            <div className="section__full--width--padding mt-4">
                <Button className="button__primary" onClick={exportProfilesToCSV}>
                    {t('common:common.export.to.csv')}
                </Button>
            </div>

            <div className="sticky-scroll">
                <PageableTableSelect
                    multiSelect={false}
                    columnConfig={columnConfig}
                    fetchPageableData={getPageableProfiles}
                    rowId="id"
                    isSticky={true}
                    stickyTopOffset={55}
                    stickyTopBarOffset={0}
                    dataName={t('common:common.profiles')}
                    additionalFilteringComponents={renderAdditionalFilteringComponents()}
                    selectable={false}
                    noDataText={renderNoResultsMessage()}
                    defaultColumnSorted="profileCreationDate"
                    handleTextFilterChange={handleTextFilterChange}
                    tableSelectRef={setTableSelectRef}
                />
            </div>
        </div>
    );
});

export default UserProfiles;
